import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, AlertController } from '@ionic/angular/lazy';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-order-refund-payment-options',
    templateUrl: './order-refund-payment-options.component.html',
    styleUrls: ['./order-refund-payment-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderRefundPaymentOptionsComponent implements OnInit {

    @Input() order_refund_payment_page = null;

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public alertController: AlertController,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    presentOrderRefundPaymentEditModal() {
        this.order_refund_payment_page.presentOrderRefundPaymentEditModal();
        this.dismiss();
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

}
